import { useEffect, useState } from "react";
import { Award, Bell, ChevronDown, Gift, Megaphone } from "lucide-react";
import { api, C } from "../lib/api";
import { fmtWhen } from "./admin/ui";

const ICON = { referral: Gift, announcement: Megaphone, system: Bell, achievement: Award };

// Inbox in the side pane as a dropdown: collapsed header with the unread count; expanding it lists everything and marks it read.
// Notifications are erased by the server after 48 hours.
export const NotificationsSection = ({ onUnread }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    api.get(C.ApiRoutes.MY_NOTIFICATIONS).then((r) => setData(r.data)).catch(() => setData({ notifications: [], unread: 0 }));
  }, []);
  useEffect(() => {
    if (!open || !data || data.unread === 0) return;
    api.post(C.ApiRoutes.MY_NOTIFICATIONS_READ, { ids: null }).then(() => { onUnread?.(0); setData((d) => ({ ...d, unread: 0 })); }).catch(() => {});
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const count = data?.notifications.length || 0;
  return (
    <section data-testid="drawer-notifications">
      <button data-testid="notifications-toggle" onClick={() => setOpen((v) => !v)} aria-expanded={open}
        className="w-full flex items-center justify-between py-1 text-left">
        <div className="text-[11px] uppercase tracking-[0.3em] gold-text flex items-center gap-2">
          <Bell className="w-3.5 h-3.5" /> Notifications
          {data?.unread > 0 && <span data-testid="notifications-unread-pill" className="rounded-full bg-red-500 text-white text-[10px] px-1.5 leading-4 tracking-normal">{data.unread}</span>}
        </div>
        <span className="text-[10px] text-slate-500 flex items-center gap-1">{count > 0 ? `${count} · last 48h` : "none"} <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} /></span>
      </button>
      {!open || !data ? null : data.notifications.length === 0 ? (
        <p className="text-xs text-slate-400 mt-2" data-testid="notifications-empty">Nothing yet — referral bonuses and announcements land here.</p>
      ) : (
        <ul className="flex flex-col divide-y divide-white/5 max-h-[300px] overflow-y-auto scroll-thin -mx-1 px-1 mt-2" data-testid="notifications-list">
          {data.notifications.map((n) => {
            const Icon = ICON[n.kind] || Bell;
            return (
              <li key={n.notif_id} data-testid="notification-item" data-unread={n.read_at ? "false" : "true"} className="py-2.5 flex gap-3">
                <div className={`mt-0.5 w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${n.read_at ? "bg-white/5 text-slate-400" : "bg-amber-400/20 text-amber-300"}`}><Icon className="w-3.5 h-3.5" /></div>
                <div className="min-w-0">
                  <div className={`text-sm leading-tight ${n.read_at ? "text-slate-200" : "text-amber-50 font-medium"}`}>{n.title}</div>
                  <div className="text-xs text-slate-400 mt-0.5">{n.body}</div>
                  <div className="text-[10px] text-slate-500 mt-1">{fmtWhen(n.created_at)}</div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};
